var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCaseSuccessDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 982,
    height: 712,
    viewBox: "0 0 982 712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M920.342 676.12C889.083 606.39 821.643 630.513 802.979 597.387C784.315 564.261 818.817 528.203 755.179 483.883C691.556 439.576 682.747 334.529 682.747 334.529C681.736 333.61 670.999 333.806 664.215 334.034C657.439 333.648 646.71 333.204 645.677 334.099C645.677 334.099 634.432 438.913 569.797 481.731C505.148 524.562 538.803 561.41 519.375 594.094C499.947 626.778 433.1 601.097 400.216 670.082C383.034 706.154 353.487 720.685 326.349 725.919L992.893 733.657C965.883 727.794 936.698 712.582 920.342 676.12Z",
    fill: "#F9FBFC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.817 313.883L664.981 314.703L644.152 313.725C644.152 313.725 635.582 320.421 635.729 334.253L664.654 334.366L665.203 334.368L694.128 334.482C694.351 320.65 685.817 313.883 685.817 313.883Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.845 249.873C696.845 249.873 697.094 263.701 709.444 268.85C721.789 273.995 739.02 282.797 739.215 316.277L690.634 316.088L696.845 249.873Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.913 249.621C632.913 249.621 632.587 263.446 620.215 268.498C607.839 273.545 590.568 282.21 590.191 315.692L638.772 315.881L632.913 249.621Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.331 317.566C698.331 317.566 710.109 184.342 665.177 139.113C620.002 183.992 631.079 317.309 631.079 317.309L698.331 317.566Z",
    fill: "#F9FBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.534 199.933C678.63 190.341 667.693 185.72 658.106 189.612C648.519 193.503 643.912 204.434 647.816 214.026C651.72 223.619 662.657 228.24 672.243 224.348C681.83 220.456 686.437 209.526 682.534 199.933Z",
    fill: "#02163D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.808 255.921C675.615 252.202 675.682 246.097 671.958 242.285C668.234 238.474 662.129 238.399 658.322 242.118C654.516 245.837 654.449 251.942 658.173 255.754C661.897 259.565 668.002 259.64 671.808 255.921Z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 651.861,
    y1: 302.582,
    x2: 672.858,
    y2: 348.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2369F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#06C1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 733.157,
    y1: 263.605,
    x2: 687.858,
    y2: 321.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2369F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#06C1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 598.164,
    y1: 253.739,
    x2: 631.218,
    y2: 325.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2369F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#06C1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 650.234,
    y1: 214.064,
    x2: 691.382,
    y2: 311.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2369F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#06C1EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.947,
    y: 329.867,
    width: 666.588,
    height: 653.423,
    transform: "rotate(0.665131 330.947 329.867)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.535,
    y: 297.044,
    width: 225.987,
    height: 227.969,
    transform: "rotate(-44.3349 503.535 297.044)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCaseSuccessDesktop);
export default __webpack_public_path__ + "static/media/bg-case-success-desktop.169d7a8466d33b4a23d3e279ac0d859d.svg";
export { ForwardRef as ReactComponent };